<template>
  <div style="padding:40px 0; position:relative; width:700px; margin:0 auto;">
    <div style="width:100%;">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 750 465" style="width:100%; enable-background:new 0 0 750 465;" xml:space="preserve">
      <g id="BACKGROUND">
      </g>
      <g id="OBJECTS">
        <g>
          <ellipse class="st0" cx="86.8" cy="398.7" rx="60" ry="10"/>
          <g>
            <path class="st1" d="M83,272c8.4,0.2,13.6,8,12.6,15.9c-0.5,3.4-5.5,1.9-5.1-1.4c0.6-4.5-2.9-9-7.5-9.2c-5.3-0.2-8.9,4.5-7.6,9.5
              c0.9,3.3-4.2,4.7-5.1,1.4C68.2,279.9,74.3,271.7,83,272z"/>
            <path class="st1" d="M44.4,403.5h75.8c3.7,0,6.6-3,6.6-6.6v-67.6c0-24.6-19.9-44.5-44.5-44.5l0,0c-24.6,0-44.5,19.9-44.5,44.5
              v67.6C37.8,400.5,40.8,403.5,44.4,403.5z"/>
            <path class="st2" d="M44.4,398.7h75.8c3.7,0,6.6-2.8,6.6-6.4c0,0,0-61.6,0-61.6c0-11.4-5.6-26.4-15.2-33.7
              c-4.2-3.2-9.4-4.9-14.6-6.5c-28.8-8.9-59.4,10.9-59.4,40.3c0,0,0,61.6,0,61.6C37.8,395.8,40.8,398.7,44.4,398.7z"/>
            <path class="st3" d="M126.1,358.2c-1.6-20.9,5.1-45.7-13.3-60.3c-4.2-3.4-9.4-5.4-14.6-6.8c-21.3-5.6-40.1,0.9-51.5,16
              c-11.4,15-9.5,35.7-5.9,53.4"/>
          </g>
          <path class="st4" d="M121,400.5h2c5.8,0,10.6-4.7,10.6-10.6v-33.4c0-5.8-4.7-10.6-10.6-10.6h-2c-5.8,0-10.6,4.7-10.6,10.6V390
            C110.4,395.8,115.1,400.5,121,400.5z"/>
          <g>
            <defs>
              <path id="SVGID_1_" d="M120.6,402.2h2c5.8,0,10.6-4.7,10.6-10.6v-33.4c0-5.8-4.7-10.6-10.6-10.6h-2c-5.8,0-10.6,4.7-10.6,10.6
                v33.4C110,397.4,114.8,402.2,120.6,402.2z"/>
            </defs>
            <clipPath id="SVGID_2_">
              <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
            </clipPath>
            <path class="st5" d="M119.5,360.3h2c5.8,0,10.6-4.7,10.6-10.6v-33.4c0-5.8-4.7-10.6-10.6-10.6h-2c-5.8,0-10.6,4.7-10.6,10.6v33.4
              C108.9,355.6,113.7,360.3,119.5,360.3z"/>
          </g>
          <path class="st4" d="M41.8,400.5h2c5.8,0,10.6-4.7,10.6-10.6v-33.4c0-5.8-4.7-10.6-10.6-10.6h-2c-5.8,0-10.6,4.7-10.6,10.6V390
            C31.2,395.8,35.9,400.5,41.8,400.5z"/>
          <g>
            <defs>
              <path id="SVGID_3_" d="M41.8,401.5h2c5.8,0,10.6-4.7,10.6-10.6v-33.4c0-5.8-4.7-10.6-10.6-10.6h-2c-5.8,0-10.6,4.7-10.6,10.6
                v33.4C31.2,396.7,35.9,401.5,41.8,401.5z"/>
            </defs>
            <clipPath id="SVGID_4_">
              <use xlink:href="#SVGID_3_"  style="overflow:visible;"/>
            </clipPath>
            <path class="st6" d="M44.8,359L44.8,359c5.2,0,9.4-4.2,9.4-9.4v-35.6c0-5.2-4.2-9.4-9.4-9.4h-4.2c-5.2,0-9.4,4.2-9.4,9.4v31.4
              C31.2,352.8,37.3,359,44.8,359z"/>
          </g>
          <path class="st7" d="M102.1,44.5c-6.8,6.4-9.8,16.4-8.5,25.6c1.3,9.2,7.2,17.7,15.3,22.2c4.1,2.3,9,3.8,11.4,7.8
            c2.4,4,1.5,9.3-0.9,13.4c-2.4,4-5.9,7.2-9,10.8c-16.4,18.8-18.1,50.4-4.7,71.4c4.7,7.4,10.8,14.5,11.6,23.2
            c0.4,4.1-0.5,8.1-1.5,12.1c-1.8,6.9-4.3,13.7-2.7,20.4c1.8,7.2,8,12.9,8.7,20.3c0.7,7.7-4.8,14.3-8,21.3
            c-3.1,6.6-4.1,14.7-0.5,21.1c3.5,6.4,12.6,9.8,18.6,5.6c4-2.7,5.7-7.8,9.2-11.1c11.5-10.6,20.3,3.3,31.1,3.6
            c10.6,0.3,18-12,27-16.2c8.9-4.1,19.3-2.1,29.1-1.2c20.1,1.8,42.2-2.2,58.1-15.3c13.8-11.3,13.3-30.9,25.6-43.6
            c8.8-9,21.8-10.1,33.6-9.5c11.8,0.7,24.1,2.7,35.3-1.8c19.3-7.6,35.4-33.7,33.7-54.2c-1-11-7-26.4-1.9-36.8
            c5.5-11.3,20.1-13.1,21.6-27.2c0.7-6.4-1.7-13.1-6.3-17.6c-4.1-4-9.6-6.1-15-8.1c-8.5-3-23.4-11-16.6-22.4
            c1.5-2.5,3.8-4.4,6.2-6.1c1.8-1.2,3.2-3,5.2-4c7.5-3.8,5.6-20.1-10.8-19.3c-16.4,0.8-43.2,25.6-61.7,14.8s-39-32.1-83-24.6
            S216,43,174.5,39.5S118.7,28.9,102.1,44.5z"/>
          <g>
            
              <rect x="119.2" y="239.9" transform="matrix(0.9761 0.2174 -0.2174 0.9761 64.588 -25.6583)" class="st8" width="59.4" height="81.7"/>
            
              <rect x="118.2" y="233.7" transform="matrix(0.9761 0.2174 -0.2174 0.9761 62.5735 -19.7511)" class="st2" width="5.6" height="81.7"/>
            <path class="st9" d="M164.9,269.9l-17.3-3.8c-3-0.7-4.9-3.7-4.2-6.7l0.4-2c0.7-3,3.7-4.9,6.7-4.2l17.3,3.8c3,0.7,4.9,3.7,4.2,6.7
              l-0.4,2C170.9,268.7,167.9,270.6,164.9,269.9z"/>
          </g>
          <g>
            <path class="st10" d="M135.9,206.4c-2.8,0-2.8,4.3,0,4.3C138.7,210.7,138.7,206.4,135.9,206.4z"/>
            <path class="st10" d="M133.5,201.8c-0.1-0.3-0.3-0.6-0.6-0.9c-0.2-0.3-0.5-0.5-0.9-0.6c-0.3-0.2-0.7-0.2-1-0.2
              c-0.2,0-0.5,0.1-0.7,0.1c-0.5,0.1-0.9,0.4-1.2,0.7c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.4-0.4,0.9-0.4,1.4v0.4c0,0.4,0.1,0.7,0.2,1
              c0.1,0.3,0.3,0.6,0.6,0.9c0.2,0.3,0.5,0.5,0.9,0.6c0.3,0.2,0.7,0.2,1,0.2c0.2,0,0.5-0.1,0.7-0.1c0.5-0.1,0.9-0.4,1.2-0.7
              c0.1-0.2,0.3-0.4,0.4-0.5c0.2-0.4,0.4-0.9,0.4-1.4v-0.4C133.8,202.5,133.7,202.2,133.5,201.8z"/>
            <path class="st10" d="M138.4,201.3c-2.1,0-2.1,3.2,0,3.2C140.5,204.5,140.5,201.3,138.4,201.3z"/>
            <path class="st10" d="M170.9,102.8c-4.9,0-4.9,7.6,0,7.6C175.7,110.4,175.7,102.8,170.9,102.8z"/>
            <path class="st10" d="M177,102.6v0.3c0,2.1,3.2,2.1,3.2,0v-0.3C180.2,100.5,177,100.5,177,102.6z"/>
            <path class="st10" d="M196.8,164.4v0.1c0,1,1.5,1,1.5,0v-0.1C198.3,163.4,196.8,163.4,196.8,164.4z"/>
            <path class="st10" d="M179.8,111.6c-3.5,0-3.5,5.4,0,5.4C183.3,117,183.3,111.6,179.8,111.6z"/>
            <path class="st10" d="M213.2,233.9c-3.5,0-3.5,5.4,0,5.4C216.7,239.3,216.7,233.9,213.2,233.9z"/>
            <path class="st10" d="M276.5,191.8c-2.8,0-2.8,4.3,0,4.3C279.2,196.1,279.2,191.8,276.5,191.8z"/>
            <path class="st10" d="M283.4,179.1c-5.6,0-5.6,8.7,0,8.7C288.9,187.7,288.9,179.1,283.4,179.1z"/>
            <path class="st10" d="M284.6,192.3c-2.1,0-2.1,3.2,0,3.2C286.7,195.6,286.7,192.3,284.6,192.3z"/>
            <path class="st10" d="M237.9,119.9c-4.9,0-4.9,7.6,0,7.6C242.7,127.5,242.8,119.9,237.9,119.9z"/>
            <path class="st10" d="M132.7,54.9c-4.9,0-4.9,7.6,0,7.6C137.6,62.5,137.6,54.9,132.7,54.9z"/>
            <path class="st10" d="M114,145.1c-4.9,0-4.9,7.6,0,7.6C118.9,152.6,118.9,145.1,114,145.1z"/>
            <path class="st10" d="M397.5,186.9c-4.9,0-4.9,7.6,0,7.6C402.3,194.5,402.4,186.9,397.5,186.9z"/>
            <path class="st10" d="M302.8,61.5c-1.4,0-1.4,2.2,0,2.2C304.2,63.7,304.2,61.5,302.8,61.5z"/>
            <path class="st10" d="M392.6,181.5c-1.4,0-1.4,2.2,0,2.2C394,183.7,394,181.5,392.6,181.5z"/>
            <path class="st10" d="M403.3,183c0-0.1-0.1-0.3-0.2-0.3c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.4-0.1-0.5-0.1c-0.1,0-0.2,0-0.3,0
              c-0.2,0.1-0.3,0.1-0.5,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.1,0,0.3,0.1,0.4
              c0,0.1,0.1,0.3,0.2,0.3c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.1,0.4,0.1,0.5,0.1l0.3,0c0.2-0.1,0.3-0.1,0.5-0.3l0.4-0.4
              c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.3,0.1-0.4C403.4,183.2,403.4,183.1,403.3,183z"/>
            <path class="st10" d="M230.6,130.3c-1.4,0-1.4,2.2,0,2.2C232,132.5,232,130.3,230.6,130.3z"/>
            <path class="st10" d="M113.8,160.8c-0.1-0.2-0.1-0.3-0.3-0.5c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.4-0.1-0.5-0.1h-0.4
              c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.3-0.1,0.4l0,0.3c0.1,0.2,0.1,0.3,0.3,0.5
              l0.2,0.2c0.2,0.1,0.4,0.1,0.5,0.1h0.4c0.1,0,0.3,0,0.4-0.1c0.1,0,0.3-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3
              c0.1-0.1,0.1-0.3,0.1-0.4C113.9,160.9,113.8,160.9,113.8,160.8z"/>
            <path class="st10" d="M119.3,165.6c-1.4,0-1.4,2.2,0,2.2C120.7,167.8,120.7,165.6,119.3,165.6z"/>
            <path class="st10" d="M123.5,153.3c0-0.1-0.1-0.3-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1l-0.3,0
              c-0.2,0.1-0.3,0.1-0.5,0.3c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.1,0.4-0.1,0.5v0.8c0,0.1,0,0.3,0.1,0.4c0,0.1,0.1,0.3,0.2,0.3
              c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.3,0.1,0.4,0.1c0.1,0,0.2,0,0.3,0c0.2-0.1,0.3-0.1,0.5-0.3c0.1-0.1,0.1-0.1,0.2-0.2
              c0.1-0.2,0.1-0.4,0.1-0.5v-0.8C123.6,153.6,123.6,153.4,123.5,153.3z"/>
            <path class="st10" d="M137.2,71.4c-1.4,0-1.4,2.2,0,2.2C138.5,73.6,138.6,71.4,137.2,71.4z"/>
            <path class="st10" d="M146.1,60.9c-1.4,0-1.4,2.2,0,2.2C147.5,63,147.5,60.9,146.1,60.9z"/>
            <path class="st10" d="M140.8,62.1c-1.4,0-1.4,2.2,0,2.2C142.2,64.3,142.2,62.1,140.8,62.1z"/>
            <path class="st10" d="M215.9,105.5c-1.4,0-1.4,2.2,0,2.2C217.3,107.7,217.3,105.5,215.9,105.5z"/>
            <path class="st10" d="M227.7,69c-1.4,0-1.4,2.2,0,2.2C229.1,71.2,229.1,69,227.7,69z"/>
            <path class="st10" d="M232.4,65.7c-0.1-0.2-0.1-0.3-0.3-0.5c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.4-0.1-0.5-0.1H231
              c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.1,0.3-0.1,0.4l0,0.3c0.1,0.2,0.1,0.3,0.3,0.5
              c0.1,0.1,0.1,0.1,0.2,0.2c0.2,0.1,0.4,0.1,0.5,0.1h0.4c0.1,0,0.3,0,0.4-0.1c0.1,0,0.3-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3
              c0.1-0.1,0.1-0.3,0.1-0.4C232.4,65.9,232.4,65.8,232.4,65.7z"/>
            <path class="st10" d="M309.3,55.5c-2.8,0-2.8,4.3,0,4.3C312.1,59.9,312.1,55.5,309.3,55.5z"/>
            <path class="st10" d="M379.7,54.3c-2.8,0-2.8,4.3,0,4.3C382.5,58.7,382.5,54.3,379.7,54.3z"/>
            <path class="st10" d="M298.9,79.3c-2.8,0-2.8,4.3,0,4.3C301.6,83.7,301.7,79.3,298.9,79.3z"/>
            <path class="st10" d="M205.8,237.4c-2.1,0-2.1,3.2,0,3.2C207.9,240.6,207.9,237.4,205.8,237.4z"/>
            <path class="st10" d="M213.1,228.1c-2.1,0-2.1,3.2,0,3.2C215.2,231.3,215.2,228.1,213.1,228.1z"/>
            <path class="st10" d="M219.2,276.8c-2.1,0-2.1,3.2,0,3.2C221.3,280,221.3,276.8,219.2,276.8z"/>
            <path class="st10" d="M220,273.5c-2.1,0-2.1,3.2,0,3.2C222.1,276.8,222.1,273.5,220,273.5z"/>
            <path class="st10" d="M308.1,235c-2.1,0-2.1,3.2,0,3.2C310.2,238.2,310.2,235,308.1,235z"/>
            <path class="st10" d="M306.1,120c-2.1,0-2.1,3.2,0,3.2C308.2,123.3,308.2,120,306.1,120z"/>
            <path class="st10" d="M310.6,117.6c-2.1,0-2.1,3.2,0,3.2C312.7,120.8,312.7,117.6,310.6,117.6z"/>
            <polygon class="st10" points="183.4,84.4 181.4,80.9 178,79 181.4,77.1 183.4,73.6 185.3,77.1 188.8,79 185.3,80.9 			"/>
            <polygon class="st10" points="202.2,158.7 200.3,155.2 196.8,153.3 200.3,151.3 202.2,147.8 204.1,151.3 207.6,153.3 
              204.1,155.2 			"/>
            <polygon class="st10" points="129.3,116.9 131.2,120.4 134.7,122.3 131.2,124.2 129.3,127.7 127.4,124.2 123.9,122.3 
              127.4,120.4 			"/>
            <polygon class="st10" points="161.7,152.5 164.4,157.5 169.4,160.2 164.4,162.9 161.7,167.8 159,162.9 154.1,160.2 159,157.5 			
              "/>
            <polygon class="st10" points="278,144.4 280.7,149.3 285.7,152.1 280.7,154.8 278,159.7 275.3,154.8 270.4,152.1 275.3,149.3 			
              "/>
            <polygon class="st10" points="394.8,74.1 397.5,79 402.5,81.7 397.5,84.4 394.8,89.4 392.1,84.4 387.2,81.7 392.1,79 			"/>
            <polygon class="st10" points="253.7,95.3 255.6,98.8 259.1,100.7 255.6,102.6 253.7,106.1 251.8,102.6 248.3,100.7 251.8,98.8 
                    "/>
            <polygon class="st10" points="299.4,48.7 301.6,52.6 305.6,54.8 301.6,57 299.4,61 297.3,57 293.3,54.8 297.3,52.6 			"/>
            <polygon class="st10" points="307.8,125.5 310.5,130.4 315.4,133.1 310.5,135.8 307.8,140.8 305.1,135.8 300.1,133.1 
              305.1,130.4 			"/>
            <polygon class="st10" points="318.6,203.4 320.5,206.9 324,208.8 320.5,210.8 318.6,214.3 316.7,210.8 313.2,208.8 316.7,206.9 
                    "/>
            <polygon class="st10" points="253.7,235.9 255.6,239.4 259.1,241.3 255.6,243.2 253.7,246.7 251.8,243.2 248.3,241.3 
              251.8,239.4 			"/>
            <polygon class="st10" points="210.4,201.2 213.1,206.1 218.1,208.8 213.1,211.6 210.4,216.5 207.7,211.6 202.8,208.8 
              207.7,206.1 			"/>
            <circle class="st10" cx="204.3" cy="166.2" r="2.5"/>
          </g>
          <g>
            
              <rect x="100.8" y="259.8" transform="matrix(0.959 -0.2833 0.2833 0.959 -79.8176 49.2847)" class="st11" width="59.4" height="81.7"/>
            
              <rect x="100.3" y="267.8" transform="matrix(0.959 -0.2833 0.2833 0.959 -83.227 41.8609)" class="st4" width="5.6" height="81.7"/>
            <path class="st9" d="M139.2,283.4l-17,5c-3,0.9-6.1-0.8-7-3.8l-0.6-1.9c-0.9-3,0.8-6.1,3.8-7l17-5c3-0.9,6.1,0.8,7,3.8l0.6,1.9
              C143.9,279.4,142.2,282.5,139.2,283.4z"/>
          </g>
          <g>
            <path class="st9" d="M379.8,71.8L379.8,71.8c2.6,11.3-4.4,22.5-15.7,25.2l-29.2,6.8c-11.3,2.6-22.5-4.4-25.2-15.7v0
              c-2.6-11.3,4.4-22.5,15.7-25.2l29.2-6.8C365.9,53.5,377.1,60.5,379.8,71.8z"/>
            <g>
              <path class="st12" d="M327.9,86.9c3.2-0.7,6.4,1.3,7.2,4.5c0.7,3.2-1.3,6.4-4.5,7.2c-3.2,0.7-6.4-1.3-7.2-4.5
                C322.7,90.9,324.7,87.6,327.9,86.9z"/>
              <path class="st4" d="M345.4,82.8c3.2-0.7,6.4,1.3,7.2,4.5c0.7,3.2-1.3,6.4-4.5,7.2c-3.2,0.7-6.4-1.3-7.2-4.5
                C340.2,86.8,342.2,83.6,345.4,82.8z"/>
              <path class="st13" d="M362.9,78.8c3.2-0.7,6.4,1.3,7.2,4.5c0.7,3.2-1.3,6.4-4.5,7.2c-3.2,0.7-6.4-1.3-7.2-4.5
                C357.7,82.7,359.7,79.5,362.9,78.8z"/>
              <path class="st14" d="M323.9,69.4c3.2-0.7,6.4,1.3,7.2,4.5c0.7,3.2-1.3,6.4-4.5,7.2c-3.2,0.7-6.4-1.3-7.2-4.5
                C318.6,73.3,320.6,70.1,323.9,69.4z"/>
              <path class="st8" d="M341.4,65.3c3.2-0.7,6.4,1.3,7.2,4.5c0.7,3.2-1.3,6.4-4.5,7.2c-3.2,0.7-6.4-1.3-7.2-4.5
                C336.1,69.3,338.1,66.1,341.4,65.3z"/>
              
                <ellipse transform="matrix(0.9989 -4.609584e-02 4.609584e-02 0.9989 -2.7096 16.676)" class="st7" cx="360.2" cy="67.1" rx="6" ry="6"/>
            </g>
          </g>
          <g>
            <defs>
              <path id="SVGID_5_" d="M118.1,360.3h4.8c5,0,9.1-4.1,9.1-9.1l9.7-52.7c0-5-12.2,0-17.3,0l-6.4,7.3c-5,0-9.1,4.1-9.1,9.1v36.3
                C108.9,356.2,113,360.3,118.1,360.3z"/>
            </defs>
            <clipPath id="SVGID_6_">
              <use xlink:href="#SVGID_5_"  style="overflow:visible;"/>
            </clipPath>
            <g class="st15">
              <path class="st16" d="M128.4,300.3l-9.1,59.9c-0.1,0.5,0.3,1.1,0.8,1.1l7.2,1.1c0.5,0.1,1.1-0.3,1.1-0.8l9.1-59.9
                c0.1-0.5-0.3-1.1-0.8-1.1l-7.2-1.1C129,299.4,128.5,299.7,128.4,300.3z"/>
              <g>
                <line class="st17" x1="134.3" y1="309.9" x2="129.1" y2="309.1"/>
                <line class="st17" x1="133" y1="318.3" x2="127.9" y2="317.5"/>
                <line class="st17" x1="131.8" y1="326.7" x2="126.6" y2="325.9"/>
                <line class="st17" x1="130.5" y1="335.1" x2="125.3" y2="334.3"/>
                <line class="st17" x1="129.2" y1="343.5" x2="124.1" y2="342.7"/>
                <line class="st17" x1="127.9" y1="351.9" x2="122.8" y2="351.1"/>
              </g>
              <g>
                <line class="st18" x1="132.7" y1="303.2" x2="130.1" y2="302.8"/>
                <line class="st18" x1="131.4" y1="311.6" x2="128.8" y2="311.2"/>
                <line class="st18" x1="130.1" y1="320" x2="127.5" y2="319.6"/>
                <line class="st18" x1="128.9" y1="328.4" x2="126.3" y2="328"/>
                <line class="st18" x1="127.6" y1="336.8" x2="125" y2="336.4"/>
                <line class="st18" x1="126.3" y1="345.2" x2="123.7" y2="344.8"/>
                <line class="st18" x1="125" y1="353.6" x2="122.5" y2="353.2"/>
              </g>
              <g>
                <line class="st18" x1="132.4" y1="305.1" x2="129.8" y2="304.7"/>
                <line class="st18" x1="131.1" y1="313.5" x2="128.5" y2="313.1"/>
                <line class="st18" x1="129.8" y1="321.9" x2="127.3" y2="321.5"/>
                <line class="st18" x1="128.6" y1="330.3" x2="126" y2="329.9"/>
                <line class="st18" x1="127.3" y1="338.7" x2="124.7" y2="338.3"/>
                <line class="st18" x1="126" y1="347.1" x2="123.4" y2="346.7"/>
                <line class="st18" x1="124.8" y1="355.5" x2="122.2" y2="355.1"/>
              </g>
              <g>
                <line class="st18" x1="132.1" y1="306.9" x2="129.5" y2="306.5"/>
                <line class="st18" x1="130.8" y1="315.3" x2="128.3" y2="314.9"/>
                <line class="st18" x1="129.6" y1="323.7" x2="127" y2="323.3"/>
                <line class="st18" x1="128.3" y1="332.1" x2="125.7" y2="331.7"/>
                <line class="st18" x1="127" y1="340.5" x2="124.4" y2="340.1"/>
                <line class="st18" x1="125.8" y1="348.9" x2="123.2" y2="348.5"/>
                <line class="st18" x1="124.5" y1="357.3" x2="121.9" y2="356.9"/>
              </g>
            </g>
          </g>
          <path class="st1" d="M45.1,403.5h74.4c4.1,0,7.4-3.3,7.4-7.4v-57c0-26.7-27.9-50.8-54.4-45.6c-20.1,4-34.6,25.6-34.6,45.6v57
            C37.8,400.2,41.1,403.5,45.1,403.5z"/>
          <path class="st4" d="M113.4,363v31.4c0,5-4.1,9.1-9.1,9.1H60.1c-5,0-9.1-4.1-9.1-9.1V363c0-5,4.1-9.1,9.1-9.1h44.2
            C109.3,354,113.4,358,113.4,363z"/>
          <g>
            <path class="st11" d="M275.7,151l-30-16.6c-1-0.6-1.4-1.8-0.8-2.8L271.8,83c0.6-1,1.8-1.4,2.8-0.8l30,16.6c1,0.6,1.4,1.8,0.8,2.8
              l-26.9,48.5C278,151.2,276.8,151.5,275.7,151z"/>
            <g>
              <path class="st19" d="M264.3,109.8l-3.1-1.7c-0.5-0.3-0.7-0.9-0.4-1.5l1.8-3.2l4.8,2.7l-1.9,3.4
                C265.3,109.8,264.7,110,264.3,109.8z"/>
              <path class="st19" d="M270.6,113.2l-2.9-1.6c-0.5-0.3-0.7-0.9-0.4-1.5l1.8-3.2l4.8,2.7l-1.8,3.2
                C271.7,113.3,271.1,113.5,270.6,113.2z"/>
              <path class="st19" d="M276.9,116.8l-2.8-1.6c-0.6-0.3-0.8-1-0.4-1.6l1.7-3.1l4.8,2.7l-1.7,3.1
                C278.2,116.9,277.5,117.1,276.9,116.8z"/>
              <path class="st19" d="M283.4,120.4l-2.9-1.6c-0.5-0.3-0.7-0.9-0.4-1.5l1.8-3.2l4.8,2.7l-1.8,3.2
                C284.6,120.5,284,120.6,283.4,120.4z"/>
              <path class="st9" d="M289.9,123.9l-3.2-1.8c-0.4-0.2-0.5-0.7-0.3-1.1l1.9-3.4l4.8,2.7l-1.8,3.2
                C291.1,124,290.4,124.2,289.9,123.9z"/>
              <path class="st19" d="M261.3,115.7l-3.7-2c-0.3-0.2-0.4-0.6-0.3-0.9l1.7-3c0.2-0.3,0.6-0.4,0.9-0.3l3.7,2
                c0.3,0.2,0.4,0.6,0.3,0.9l-1.7,3C262,115.8,261.6,115.9,261.3,115.7z"/>
              <path class="st19" d="M267.7,119.3l-3.7-2c-0.3-0.2-0.4-0.6-0.3-0.9l1.7-3c0.2-0.3,0.6-0.4,0.9-0.3l3.7,2
                c0.3,0.2,0.4,0.6,0.3,0.9l-1.7,3C268.4,119.3,268,119.4,267.7,119.3z"/>
              <path class="st19" d="M274.1,122.8l-3.7-2c-0.3-0.2-0.4-0.6-0.3-0.9l1.7-3c0.2-0.3,0.6-0.4,0.9-0.3l3.7,2
                c0.3,0.2,0.4,0.6,0.3,0.9l-1.7,3C274.8,122.9,274.5,123,274.1,122.8z"/>
              <path class="st19" d="M280.6,126.4l-3.7-2c-0.3-0.2-0.4-0.6-0.3-0.9l1.7-3c0.2-0.3,0.6-0.4,0.9-0.3l3.7,2
                c0.3,0.2,0.4,0.6,0.3,0.9l-1.7,3C281.3,126.5,280.9,126.6,280.6,126.4z"/>
              <path class="st9" d="M287,130l-3.7-2c-0.3-0.2-0.4-0.6-0.3-0.9l1.7-3c0.2-0.3,0.6-0.4,0.9-0.3l3.7,2c0.3,0.2,0.4,0.6,0.3,0.9
                l-1.7,3C287.7,130,287.3,130.1,287,130z"/>
              <path class="st19" d="M258,121.5l-3.7-2c-0.3-0.2-0.4-0.6-0.3-0.9l1.7-3c0.2-0.3,0.6-0.4,0.9-0.3l3.7,2c0.3,0.2,0.4,0.6,0.3,0.9
                l-1.7,3C258.7,121.6,258.3,121.7,258,121.5z"/>
              <path class="st19" d="M264.5,125.1l-3.7-2c-0.3-0.2-0.4-0.6-0.3-0.9l1.7-3c0.2-0.3,0.6-0.4,0.9-0.3l3.7,2
                c0.3,0.2,0.4,0.6,0.3,0.9l-1.7,3C265.2,125.2,264.8,125.3,264.5,125.1z"/>
              <path class="st19" d="M270.9,128.7l-3.7-2c-0.3-0.2-0.4-0.6-0.3-0.9l1.7-3c0.2-0.3,0.6-0.4,0.9-0.3l3.7,2
                c0.3,0.2,0.4,0.6,0.3,0.9l-1.7,3C271.6,128.7,271.2,128.8,270.9,128.7z"/>
              <path class="st19" d="M277.3,132.2l-3.7-2c-0.3-0.2-0.4-0.6-0.3-0.9l1.7-3c0.2-0.3,0.6-0.4,0.9-0.3l3.7,2
                c0.3,0.2,0.4,0.6,0.3,0.9l-1.7,3C278.1,132.3,277.7,132.4,277.3,132.2z"/>
              <path class="st19" d="M283.8,135.8l-3.7-2c-0.3-0.2-0.4-0.6-0.3-0.9l1.7-3c0.2-0.3,0.6-0.4,0.9-0.3l3.7,2
                c0.3,0.2,0.4,0.6,0.3,0.9l-1.7,3C284.5,135.9,284.1,136,283.8,135.8z"/>
              <path class="st9" d="M254.7,127.3l-3.5-1.9c-0.4-0.2-0.5-0.6-0.3-1l1.6-2.8c0.2-0.4,0.6-0.5,1-0.3l3.5,1.9
                c0.4,0.2,0.5,0.6,0.3,1l-1.6,2.8C255.5,127.4,255.1,127.5,254.7,127.3z"/>
              <path class="st19" d="M260.5,130.5l-2.7-1.5c-0.4-0.2-0.6-0.7-0.3-1.2l1.5-2.6c0.2-0.4,0.8-0.6,1.2-0.3l3.3,1.8
                c0.4,0.2,0.6,0.8,0.3,1.2l-1.1,2C262.1,130.6,261.2,130.9,260.5,130.5z"/>
              <path class="st19" d="M267.5,134.4l-3.4-1.9c-0.4-0.2-0.5-0.7-0.3-1.1l1.5-2.7c0.2-0.4,0.7-0.6,1.2-0.3l3.4,1.9
                c0.4,0.2,0.5,0.7,0.3,1.1l-1.5,2.7C268.4,134.5,267.9,134.6,267.5,134.4z"/>
              <path class="st19" d="M273.9,138l-3.3-1.8c-0.4-0.2-0.6-0.7-0.3-1.2l1.5-2.6c0.2-0.4,0.7-0.6,1.2-0.3l3.3,1.8
                c0.4,0.2,0.6,0.7,0.3,1.2l-1.5,2.6C274.9,138.1,274.3,138.2,273.9,138z"/>
              <path class="st19" d="M277.9,147.8l-4.8-2.7l5.1-9.2c0.2-0.4,0.7-0.5,1.1-0.3l3.4,1.9c0.4,0.2,0.5,0.7,0.3,1.1L277.9,147.8z"/>
              <path class="st13" d="M252.1,133.5l-5-2.6l2.1-3.5c0.2-0.4,0.6-0.5,1-0.3l3.5,2c0.4,0.2,0.5,0.6,0.3,1L252.1,133.5z"/>
              <path class="st19" d="M258.6,137.1l-4.8-2.7l1.9-3.4c0.2-0.4,0.8-0.6,1.2-0.3l3.3,1.8c0.4,0.2,0.6,0.8,0.3,1.2L258.6,137.1z"/>
              <path class="st19" d="M265,140.7l-4.8-2.7l1.9-3.4c0.2-0.4,0.8-0.6,1.2-0.3l3.3,1.8c0.4,0.2,0.6,0.8,0.3,1.2L265,140.7z"/>
              <path class="st19" d="M271.4,144.2l-4.8-2.7l1.9-3.4c0.2-0.4,0.8-0.6,1.2-0.3l3.3,1.8c0.4,0.2,0.6,0.8,0.3,1.2L271.4,144.2z"/>
            </g>
            
              <rect x="267.5" y="94.6" transform="matrix(0.8746 0.4849 -0.4849 0.8746 84.3381 -125.1792)" class="st9" width="33.4" height="11.8"/>
          </g>
          <line class="st20" x1="113.4" y1="364.2" x2="51" y2="364.2"/>
          <g>
            <path class="st4" d="M52.5,331.1c4.6-11.7,15.9-20,29.2-20h0c13.3,0,24.7,8.3,29.2,20H52.5z"/>
            <path class="st21" d="M53.7,331.8c4.4-9.5,15.3-16.3,28-16.3h0c12.8,0,23.7,6.8,28,16.3"/>
          </g>
          <g>
            <path class="st8" d="M297.4,226.5l-4.3-0.5c-0.4-0.1-0.8-0.5-0.7-0.9l4.1-33.9c0.1-0.4,0.5-0.8,0.9-0.7l4.3,0.5
              c0.4,0.1,0.8,0.5,0.7,0.9l-4.1,33.9C298.3,226.3,297.9,226.6,297.4,226.5z"/>
            
              <rect x="294.5" y="192.9" transform="matrix(0.9926 0.1212 -0.1212 0.9926 27.4398 -34.5225)" class="st9" width="6" height="30.7"/>
            <path class="st8" d="M301.6,191l-4-0.5l2-5.8c0.1-0.2,0.3-0.4,0.6-0.4l0.4,0.1c0.3,0,0.5,0.2,0.5,0.5L301.6,191z"/>
            
              <rect x="296" y="195.2" transform="matrix(0.9926 0.1212 -0.1212 0.9926 25.9424 -34.8037)" class="st22" width="6" height="1.1"/>
            
              <rect x="295.7" y="197.7" transform="matrix(0.9926 0.1212 -0.1212 0.9926 26.2304 -34.7448)" class="st22" width="6" height="1.1"/>
          </g>
          <g>
            <path class="st1" d="M286.2,208.3l1.8,4.5c0.2,0.5,0,1-0.5,1.2l-35.4,14.1c-0.5,0.2-1,0-1.2-0.5l-1.8-4.5c-0.2-0.5,0-1,0.5-1.2
              l35.4-14.1C285.5,207.6,286,207.8,286.2,208.3z"/>
            
              <rect x="265" y="201" transform="matrix(-0.3712 -0.9286 0.9286 -0.3712 165.4459 548.1991)" class="st9" width="6.7" height="34.3"/>
            <path class="st1" d="M249.2,223.3l1.7,4.1l-6.7,1.2c-0.3,0.1-0.6-0.1-0.7-0.4l-0.2-0.4c-0.1-0.3,0-0.6,0.2-0.7L249.2,223.3z"/>
            
              <rect x="252" y="222.7" transform="matrix(-0.3712 -0.9286 0.9286 -0.3712 142.7483 543.243)" class="st22" width="6.7" height="1.2"/>
            
              <rect x="254.5" y="221.7" transform="matrix(-0.3712 -0.9286 0.9286 -0.3712 147.1709 544.2092)" class="st22" width="6.7" height="1.2"/>
          </g>
          <g>
            <path class="st11" d="M140.8,89.5l-3.6,3.1c-0.4,0.3-1,0.3-1.3-0.1l-24.4-28.7c-0.3-0.4-0.3-1,0.1-1.3l3.6-3.1
              c0.4-0.3,1-0.3,1.3,0.1l24.4,28.7C141.3,88.6,141.2,89.2,140.8,89.5z"/>
            
              <rect x="122.7" y="58.8" transform="matrix(0.7628 -0.6467 0.6467 0.7628 -19.0995 99.4927)" class="st9" width="6.6" height="33.9"/>
            <path class="st11" d="M115.1,59.5l-3.4,2.9l-3.2-5.9c-0.1-0.3-0.1-0.6,0.1-0.8l0.4-0.3c0.2-0.2,0.5-0.2,0.8,0L115.1,59.5z"/>
            
              <rect x="113.8" y="64.6" transform="matrix(0.7628 -0.6467 0.6467 0.7628 -14.3844 91.1797)" class="st22" width="6.6" height="1.2"/>
            
              <rect x="115.5" y="66.6" transform="matrix(0.7628 -0.6467 0.6467 0.7628 -15.3023 92.7984)" class="st22" width="6.6" height="1.2"/>
          </g>
          <g>
            <polygon class="st23" points="162.2,74.5 156,72.1 164,50.7 170.2,53.1 			"/>
            <polygon class="st8" points="134.2,149.2 128,146.8 163.3,52.8 169.5,55.2 			"/>
            <polygon class="st24" points="127.2,157.3 127.8,146.8 134,149.1 			"/>
            <polygon class="st4" points="127.5,152.8 127.2,157.3 130.2,153.8 			"/>
          </g>
          <g>
            <polygon class="st23" points="242.4,213.9 236.8,210.2 249.8,191.1 255.4,194.8 			"/>
            <polygon class="st25" points="197,280.7 191.4,276.9 248.6,193 254.2,196.7 			"/>
            <polygon class="st24" points="188.1,287 191.2,276.8 196.8,280.6 			"/>
            <polygon class="st25" points="189.4,282.6 188.1,287 191.9,284.2 			"/>
          </g>
          <g>
            <polygon class="st23" points="255.8,180.7 252.1,175.1 271.6,162.6 275.3,168.3 			"/>
            <polygon class="st4" points="187.8,224.3 184.1,218.7 269.8,163.9 273.5,169.5 			"/>
            <polygon class="st24" points="177.1,226.7 184,218.5 187.7,224.1 			"/>
            <polygon class="st11" points="180.1,223.1 177.1,226.7 181.7,225.6 			"/>
          </g>
          <g>
            
              <rect x="174.4" y="135.9" transform="matrix(8.198829e-02 -0.9966 0.9966 8.198829e-02 30.8424 311.2293)" class="st26" width="20" height="6"/>
            <path class="st19" d="M185.1,134.5c1.2,0.1,2,2.2,1.8,4.8c-0.2,2.5-1.4,4.5-2.6,4.4s-2-2.2-1.8-4.8
              C182.8,136.4,183.9,134.4,185.1,134.5z"/>
            <polygon class="st14" points="182.6,128.7 181,148.6 162.9,145.5 152.7,146.3 154.3,126.4 164.5,128.8 			"/>
            
              <rect x="164.6" y="121.7" transform="matrix(8.199354e-02 -0.9966 0.9966 8.199354e-02 18.5688 291.9681)" class="st26" width="6.4" height="28.4"/>
            
              <rect x="154.3" y="131.9" transform="matrix(8.198528e-02 -0.9966 0.9966 8.198528e-02 9.1812 282.1294)" class="st26" width="6.8" height="8.4"/>
            
              <rect x="164.3" y="120.5" transform="matrix(8.199238e-02 -0.9966 0.9966 8.199238e-02 19.8496 290.9697)" class="st27" width="7.2" height="28.4"/>
            
              <rect x="164.3" y="119.7" transform="matrix(8.199187e-02 -0.9966 0.9966 8.199187e-02 20.7035 290.304)" class="st28" width="7.2" height="28.4"/>
            <g>
              <path class="st27" d="M164.9,131.3c1.1,0.1,1.9,1.1,1.8,2.2c-0.1,1.1-1.1,1.9-2.2,1.8c-1.1-0.1-1.9-1.1-1.8-2.2
                C162.8,132,163.8,131.2,164.9,131.3z"/>
              <g>
                <line class="st29" x1="163.6" y1="133.2" x2="165.9" y2="133.4"/>
                <line class="st29" x1="164.6" y1="134.5" x2="164.8" y2="132.1"/>
              </g>
            </g>
          </g>
          <g>
            <g>
              <g>
                <path class="st30" d="M153,189.9l12.7,58.6c0.2,1,1.7,0.8,1.6-0.2l-1.6-49.8c0-0.1-0.1-0.1-0.1-0.1l-5.4,1.2
                  c-0.1,0-0.1,0-0.1-0.1l-2.1-9.9L153,189.9z"/>
                <path class="st1" d="M160.2,192.5l-5.8-26.7c-1.1-5.1-6.1-8.3-11.2-7.2l-0.3,0.1c-5.1,1.1-8.4,6.2-7.2,11.3
                  c0,0.1,0,0.2,0.1,0.3c0.9,3.9,3.4,7.2,6.6,9.5c0.5,0.4,1,0.8,1.5,1.2c2.2,2,4.1,4.4,5.6,7c1.1,2,2,4.2,2.8,6.4L160.2,192.5z
                  M152,167.8c2,7.2-1.3,7.7-4.9,8.4c-3.5,0.8-7.1-1.8-7.9-5.7s1.3-7.7,4.9-8.4C147.6,161.4,150.9,164,152,167.8z"/>
              </g>
              <g>
                <path class="st9" d="M171.8,192.1L146,246.2c-0.4,0.9-1.8,0.4-1.5-0.6l13-48.1c0-0.1,0.1-0.1,0.1-0.1l5,2.4
                  c0.1,0,0.1,0,0.1-0.1l4.4-9.1L171.8,192.1z"/>
                <path class="st1" d="M171.4,196.4c1.3-2,2.6-3.8,4.2-5.6c2-2.2,4.4-4.1,7-5.5c0.6-0.3,1.2-0.6,1.8-0.8c3.7-1.5,6.8-4.1,8.6-7.7
                  c0-0.1,0.1-0.2,0.1-0.2c2.3-4.7,0.3-10.4-4.4-12.6l-0.2-0.1c-4.7-2.2-10.4-0.2-12.6,4.5L164.2,193L171.4,196.4z M186.9,167.1
                  c3.3,1.6,4.5,5.7,2.8,9.3c-1.7,3.6-5.7,5.3-9,3.7c-3.3-1.6-6.4-2.7-2.8-9.3C179.8,167.3,183.7,165.6,186.9,167.1z"/>
              </g>
            </g>
            <path class="st31" d="M158.1,203.6c0.2-1.6,1.6-2.7,3.2-2.5c1.6,0.2,2.7,1.6,2.5,3.2c-0.2,1.6-1.6,2.7-3.2,2.5
              C159,206.6,157.9,205.2,158.1,203.6z"/>
          </g>
          <path class="st32" d="M213.1,179.8l9.8-6.2c1.3-0.9,1.7-2.6,0.9-4l0,0c-0.9-1.3-2.6-1.7-4-0.9l-8.9,5.7c-1.7,1.1-2.2,3.3-1.1,5
            l0,0c1.1,1.7,3.3,2.2,5,1.1l12.2-7.8c1.9-1.2,2.5-3.8,1.3-5.7l0,0c-1.3-2-3.9-2.5-5.8-1.2l-8.9,5.7"/>
          <path class="st33" d="M245.6,165l-0.8-11.5c-0.1-1.6-1.5-2.8-3.1-2.7l0,0c-1.6,0.1-2.8,1.5-2.7,3.1l0.8,10.5
            c0.1,2,1.9,3.5,3.9,3.3l0,0c2-0.1,3.5-1.9,3.3-3.9l-1-14.5c-0.2-2.3-2.2-4-4.4-3.9l0,0c-2.3,0.2-4.1,2.2-3.8,4.5l0.8,10.5"/>
          <path class="st34" d="M220.8,159.1l6.5-9.6c0.9-1.3,0.5-3.1-0.8-4l0,0c-1.3-0.9-3.1-0.5-4,0.8l-5.9,8.8c-1.1,1.7-0.7,3.9,1,5l0,0
            c1.7,1.1,3.9,0.7,5-1l8.1-12c1.3-1.9,0.8-4.5-1.1-5.8l0,0c-1.9-1.3-4.5-0.8-5.8,1.2l-5.9,8.7"/>
          <g>
            <g>
              
                <rect x="310.7" y="128" transform="matrix(0.8349 -0.5505 0.5505 0.8349 -36.6327 213.9972)" class="st9" width="55.3" height="80.2"/>
              <g>
                <line class="st35" x1="295.8" y1="157.1" x2="300.7" y2="153.8"/>
                <line class="st35" x1="299.1" y1="162.2" x2="304.1" y2="158.9"/>
                <line class="st35" x1="302.5" y1="167.3" x2="307.4" y2="164.1"/>
                <line class="st35" x1="305.9" y1="172.4" x2="310.8" y2="169.2"/>
                <line class="st35" x1="309.2" y1="177.5" x2="314.2" y2="174.3"/>
                <line class="st35" x1="312.6" y1="182.6" x2="317.5" y2="179.4"/>
                <line class="st35" x1="316" y1="187.7" x2="320.9" y2="184.5"/>
                <line class="st35" x1="319.3" y1="192.8" x2="324.3" y2="189.6"/>
                <line class="st35" x1="322.7" y1="197.9" x2="327.6" y2="194.7"/>
                <line class="st35" x1="326.1" y1="203" x2="331" y2="199.8"/>
                <line class="st35" x1="329.4" y1="208.2" x2="334.4" y2="204.9"/>
                <line class="st35" x1="332.8" y1="213.3" x2="337.7" y2="210"/>
              </g>
            </g>
            
              <rect x="318.3" y="125.7" transform="matrix(0.8367 -0.5477 0.5477 0.8367 -34.9768 214.2809)" class="st1" width="47" height="80.2"/>
            
              <rect x="318.6" y="143.8" transform="matrix(0.8367 -0.5477 0.5477 0.8367 -27.3089 204.6946)" class="st19" width="22" height="8.6"/>
          </g>
          <g>
            <path class="st9" d="M252.8,76.2l-62.7,22.6c-0.3,0.1-0.5,0.5-0.4,0.8l14.8,41c0.2,0.5,0.8,0.6,1.1,0.2l47.9-63.6
              C253.9,76.7,253.4,76,252.8,76.2z M202.4,103.7l27.4-9.9c0.6-0.2,1.1,0.5,0.7,1l-21.4,26.5c-0.3,0.4-0.9,0.3-1.1-0.2l-6-16.6
              C201.9,104.2,202.1,103.9,202.4,103.7z"/>
            <g>
              <line class="st36" x1="244.1" y1="86.3" x2="242.4" y2="81.9"/>
              <line class="st36" x1="236.8" y1="88.9" x2="235.2" y2="84.5"/>
              <line class="st36" x1="229.6" y1="91.5" x2="228" y2="87.1"/>
              <line class="st36" x1="222.4" y1="94.1" x2="220.8" y2="89.7"/>
              <line class="st36" x1="215.1" y1="96.7" x2="213.5" y2="92.3"/>
              <line class="st36" x1="207.9" y1="99.3" x2="206.3" y2="94.9"/>
              <line class="st36" x1="200.7" y1="102" x2="199.1" y2="97.5"/>
            </g>
            <g>
              <line class="st37" x1="241.4" y1="84.7" x2="240.6" y2="82.5"/>
              <line class="st37" x1="234.2" y1="87.4" x2="233.4" y2="85.1"/>
              <line class="st37" x1="227" y1="90" x2="226.2" y2="87.7"/>
              <line class="st37" x1="219.7" y1="92.6" x2="218.9" y2="90.3"/>
              <line class="st37" x1="212.5" y1="95.2" x2="211.7" y2="93"/>
              <line class="st37" x1="205.3" y1="97.8" x2="204.5" y2="95.6"/>
              <line class="st37" x1="198.1" y1="100.4" x2="197.3" y2="98.2"/>
            </g>
            <g>
              <line class="st37" x1="239.8" y1="85.3" x2="239" y2="83.1"/>
              <line class="st37" x1="232.6" y1="87.9" x2="231.8" y2="85.7"/>
              <line class="st37" x1="225.4" y1="90.5" x2="224.6" y2="88.3"/>
              <line class="st37" x1="218.1" y1="93.1" x2="217.3" y2="90.9"/>
              <line class="st37" x1="210.9" y1="95.8" x2="210.1" y2="93.5"/>
              <line class="st37" x1="203.7" y1="98.4" x2="202.9" y2="96.1"/>
              <line class="st37" x1="196.5" y1="101" x2="195.7" y2="98.7"/>
            </g>
            <g>
              <line class="st37" x1="238.2" y1="85.9" x2="237.4" y2="83.7"/>
              <line class="st37" x1="231" y1="88.5" x2="230.2" y2="86.3"/>
              <line class="st37" x1="223.8" y1="91.1" x2="223" y2="88.9"/>
              <line class="st37" x1="216.6" y1="93.7" x2="215.8" y2="91.5"/>
              <line class="st37" x1="209.3" y1="96.3" x2="208.5" y2="94.1"/>
              <line class="st37" x1="202.1" y1="98.9" x2="201.3" y2="96.7"/>
              <line class="st37" x1="194.9" y1="101.5" x2="194.1" y2="99.3"/>
            </g>
            <g>
              <g>
                <line class="st36" x1="206.1" y1="130.6" x2="202.3" y2="132"/>
                <line class="st36" x1="203.1" y1="122.2" x2="199.2" y2="123.6"/>
                <line class="st36" x1="200.1" y1="113.8" x2="196.2" y2="115.2"/>
                <line class="st36" x1="197" y1="105.4" x2="193.2" y2="106.8"/>
              </g>
              <g>
                <line class="st37" x1="204.9" y1="133.1" x2="202.9" y2="133.8"/>
                <line class="st37" x1="201.8" y1="124.7" x2="199.9" y2="125.4"/>
                <line class="st37" x1="198.8" y1="116.3" x2="196.9" y2="117"/>
                <line class="st37" x1="195.8" y1="107.9" x2="193.8" y2="108.6"/>
              </g>
              <g>
                <line class="st37" x1="205.5" y1="134.8" x2="203.5" y2="135.5"/>
                <line class="st37" x1="202.4" y1="126.4" x2="200.5" y2="127.1"/>
                <line class="st37" x1="199.4" y1="118" x2="197.5" y2="118.7"/>
                <line class="st37" x1="196.4" y1="109.7" x2="194.5" y2="110.4"/>
              </g>
              <g>
                <line class="st37" x1="206.1" y1="136.5" x2="204.2" y2="137.2"/>
                <line class="st37" x1="203.1" y1="128.1" x2="201.1" y2="128.8"/>
                <line class="st37" x1="200" y1="119.8" x2="198.1" y2="120.4"/>
                <line class="st37" x1="197" y1="111.4" x2="195.1" y2="112.1"/>
              </g>
              <g>
                <line class="st37" x1="206.7" y1="138.2" x2="204.8" y2="138.9"/>
                <line class="st37" x1="203.7" y1="129.8" x2="201.7" y2="130.5"/>
                <line class="st37" x1="200.6" y1="121.5" x2="198.7" y2="122.2"/>
                <line class="st37" x1="197.6" y1="113.1" x2="195.7" y2="113.8"/>
              </g>
            </g>
          </g>
          <g>
            <path class="st25" d="M297.7,255.3c1.4,7.4-3.4,14.5-10.8,16c-7.4,1.4-14.5-3.4-16-10.8c-1.4-7.4,3.4-14.5,10.8-16
              C289.1,243.1,296.2,247.9,297.7,255.3z"/>
            <path class="st38" d="M308,258.5c-4.5,2.3-11.9,4.7-20.4,6.4c-14.5,2.8-26.8,2.5-27.5-0.7c-0.6-3.2,10.7-8.1,25.2-11
              c14.5-2.8,26.8-2.5,27.5,0.7C313,255.3,311.2,256.9,308,258.5"/>
            <path class="st25" d="M270.9,260.5c-1.4-7.4,3.4-14.5,10.8-16c7.4-1.4,14.5,3.4,16,10.8"/>
          </g>
          <g>
            <line class="st39" x1="238.3" y1="254.1" x2="227.5" y2="270.3"/>
            <path class="st13" d="M242.9,254.6c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4c0-3,2.4-5.4,5.4-5.4
              C240.4,249.2,242.9,251.6,242.9,254.6z"/>
          </g>
          <g>
            <line class="st39" x1="112.5" y1="182.7" x2="131.8" y2="185.5"/>
            <path class="st13" d="M111,178.4c2.7-1.3,5.9-0.1,7.2,2.6c1.3,2.7,0.1,5.9-2.6,7.2c-2.7,1.3-5.9,0.1-7.2-2.6
              C107.1,182.9,108.3,179.7,111,178.4z"/>
          </g>
          <g>
            <path class="st13" d="M217.7,61.9c-0.7,5.7-4.4,11.4-9.2,13.6c-1.5,0.7-3.4,1.4-5.1,1c-0.7-0.2-1.4-0.5-2.1-0.5
              c-1-0.1-1.8,0.5-2.8,0.7c-1.1,0.2-2.2,0-3.2-0.4c-6.5-2.3-10.1-10.6-9.9-17.1c0.1-5.7,4.3-10.8,10.2-10.8c1,0,2,0.1,2.8,0.5
              c0.9,0.4,1.7,1.1,2.1,2c1.3-1.7,4.1-2.3,6.1-2.3c2.2,0,4.5,0.6,6.3,1.8C217,53,218.3,57.4,217.7,61.9z"/>
            <g>
              <path class="st40" d="M201.2,53.4c-0.1-2.5,1-4.9,2.6-6.6c1.6-1.8,3.8-3.1,6.1-3.9l0.5,1.7c-2.1,0.6-4,1.6-5.6,3.1
                c-1.5,1.5-2.6,3.5-2.6,5.6L201.2,53.4z"/>
            </g>
            <path class="st41" d="M195.1,53.4c-2.5,2.4-4.1,5.7-4.2,9.2c-0.2,3.4,1.1,6.9,3.3,9.5"/>
          </g>
          <g>
            <rect x="318.5" y="112.8" transform="matrix(-0.475 0.88 -0.88 -0.475 573.9222 -110.8471)" class="st19" width="3" height="6"/>
            <g>
              <polyline class="st19" points="327.7,118.6 329.3,114 327.3,113.1 322.2,114.8 327.6,118.2 				"/>
            </g>
            <g>
              <polygon class="st19" points="352.3,126.6 352.8,125.7 327.3,112.3 321.4,114.5 321.8,115.5 327.2,113.4 				"/>
            </g>
            
              <rect x="356.4" y="92.4" transform="matrix(-0.475 0.88 -0.88 -0.475 650.3094 -114.1385)" class="st14" width="5.6" height="89"/>
            <g>
              <path class="st19" d="M338.4,118.5c0.7,0.7,1.4,1.5,2.2,2.2c1,1,2,2.1,3.3,2.7c1.3,0.6,2.9,0.8,4.2,0.1"/>
            </g>
            <polygon class="st9" points="406.4,162 399.8,155.4 397.1,160.4 			"/>
            <polygon class="st13" points="403.6,159.2 406.4,162 402.4,161.3 			"/>
          </g>
          <g>
            <path class="st1" d="M224.9,41.5L224.9,41.5c0.4-0.9,1.5-1.3,2.4-0.9l50.3,23.3l-1.6,3.5l-50.2-23.4
              C224.9,43.5,224.5,42.4,224.9,41.5z"/>
            
              <rect x="269.7" y="53.6" transform="matrix(-0.4198 0.9076 -0.9076 -0.4198 442.9883 -156.8161)" class="st24" width="3.8" height="19.1"/>
            <path class="st13" d="M277.2,62.2c3.1-1.9,6.7-1.5,9.5,0.6c3,2.3,4.4,6,5.3,9.5c0.1,0.5,0.3,2.9,0.7,3.1c-3.4-2.2-7-2.6-11-2.6
              c-3.7,0.1-7.8-1.9-7.4-6.2C274.5,64.7,275.6,63.2,277.2,62.2z"/>
          </g>
          <g>
            <path class="st9" d="M246.4,285.4l-6.3,5.4c-0.4,0.4-1.1,0.3-1.5-0.1l-8.3-9.8c-0.4-0.4-0.3-1.1,0.1-1.5l6.3-5.4
              c0.4-0.4,1.1-0.3,1.5,0.1l8.3,9.8C246.9,284.3,246.8,285,246.4,285.4z"/>
            <path class="st2" d="M240.9,284.6c-0.2,0.4-0.7,0.6-1.1,0.5c-0.4-0.1-0.7-0.4-0.7-0.8c0-0.5,0.4-0.9,0.6-1.4
              c0.2-0.4,0.2-0.9,0.1-1.3c-0.3-1.2-1.7-1-2.6-0.9c-0.1,0-0.6,0.1-0.6,0c-0.1-0.1,0.1-0.5,0.1-0.6c0.2-0.5,0.5-0.9,0.9-1.2
              c0.5-0.4-0.2-1.1-0.7-0.7c-0.7,0.6-1.4,1.6-1.3,2.5c0.1,1.3,1.7,1,2.5,1c0.4,0,0.8,0,0.8,0.4c0,0.4-0.3,0.8-0.5,1.2
              c-0.4,0.9-0.3,1.9,0.6,2.5c1,0.6,2.2,0.1,2.8-0.8C242.1,284.6,241.2,284,240.9,284.6z"/>
          </g>
          <g>
            <path class="st42" d="M375.6,135.3l0.1-25.9c0-2.4,2-4.4,4.5-4.4l1.6,0"/>
            <path class="st43" d="M392.4,121.7c4.2,4.2,4.1,11-0.1,15.2c-4.2,4.2-11,4.1-15.2-0.1c-4.2-4.2-4.1-11,0.1-15.2
              C381.4,117.5,388.2,117.5,392.4,121.7z"/>
            
              <ellipse transform="matrix(5.414871e-03 -1 1 5.414871e-03 295.7353 513.6783)" class="st43" cx="406.1" cy="108.2" rx="10.7" ry="10.7"/>
            <path class="st42" d="M392.4,121.7c4.2,4.2,4.1,11-0.1,15.2c-4.2,4.2-11,4.1-15.2-0.1c-4.2-4.2-4.1-11,0.1-15.2
              C381.4,117.5,388.2,117.5,392.4,121.7z"/>
            
              <ellipse transform="matrix(5.414871e-03 -1 1 5.414871e-03 295.7353 513.6783)" class="st42" cx="406.1" cy="108.2" rx="10.7" ry="10.7"/>
            <line class="st42" x1="390.9" y1="120.2" x2="397" y2="114.2"/>
            <path class="st42" d="M412.2,99.1l0.1-25.9c0-2.4,2-4.4,4.5-4.4l1.6,0"/>
          </g>
          <path class="st16" d="M68.3,380.6c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3
            C66.4,376.2,68.3,378.2,68.3,380.6z"/>
          <path class="st2" d="M99.9,393.3l-7-4.2c-1.1-0.7-1.5-2.2-0.8-3.3l4.2-7c0.7-1.1,2.2-1.5,3.3-0.8l7,4.2c1.1,0.7,1.5,2.2,0.8,3.3
            l-4.2,7C102.5,393.6,101,394,99.9,393.3z"/>
          <path class="st7" d="M74.3,386.1c-2.8-2-6.7-1.6-8.9,1.2c-2.2,2.7-1.8,6.7,0.8,8.9L74.3,386.1z"/>
          <path class="st20" d="M126.6,362.3c2.6-1.1,4.8-3.3,5.8-6"/>
          <path class="st20" d="M32.4,355.4c0.7,1.9,2.1,3.6,3.8,4.7c0.6,0.4,1.3,0.7,2.1,0.8"/>
          <g>
            <defs>
              <path id="SVGID_7_" d="M82.3,284.7L82.3,284.7c-24.6,0-44.5,19.9-44.5,44.5v3.3v6.6v7.2c-3.8,1.1-6.6,4.6-6.6,8.8v36.3
                c0,4.2,2.8,7.7,6.6,8.8l0,0c0,1.8,1.5,3.3,3.3,3.3h3.3h15.6h44.2h16l0,0c3.7,0,6.6-3,6.6-6.6v0v-57.7v-6.6v-3.3
                C126.9,304.6,106.9,284.7,82.3,284.7z"/>
            </defs>
            <clipPath id="SVGID_8_">
              <use xlink:href="#SVGID_7_"  style="overflow:visible;"/>
            </clipPath>
            <path class="st44" d="M130.7,399.6c-0.4-0.6-7.2,0-7.9,0c-6.1,0-12.2,0-18.3,0c-12.3,0-30.6,3.2-37.9-9.7
              c-1.6-2.9-2.2-6.2-2.6-9.5c-0.9-8.7,0.1-17.5,2.7-25.8c-1.6-0.7-3.4,0.1-5.1,0.3c-5.4,0.6-3.1-8.1-3.1-11.3c0-3.8,0-7.7,0-11.5
              h0.8c0-0.3,0-0.6-0.1-0.9c1.1,0.7,2.6,0.6,3.8,0v-10.6c0,0-0.1-0.1-0.1-0.1c-4.2,1.1-4.8-0.4-5.9-4.6c-0.9-3.7-0.7-7.6,0.3-11.3
              c0-0.2-0.1-0.4-0.2-0.7c-0.2-0.7-0.7-1.4-0.9-2.1c-1.4-4.2,5.9-8.3,2.9-11.3c-2.9-2.9-10.6-0.2-13.4,1.4
              c-4.4,2.6-7.7,6.6-10.5,10.8c-15.9,23.8-19.5,53.9-17.3,82.5c0.5,5.8,1.2,11.7,3.5,17c4.7,11,15.9,18.3,27.6,20.5
              c8.5,1.6,17.4,0.7,25.7-1.5c3.1-0.8,6.9-1.6,9.7-3.2c3-1.8,4.8-3.9,8.5-4.5c3.5-0.6,7.1-0.1,10.7,0.2c5.8,0.5,11.6,0.4,17.3-0.8
              c3.1-0.7,6.3-1.8,8.5-4C132,406.3,132.4,402.4,130.7,399.6z"/>
          </g>
        </g>
        <circle class="st45" cx="259.3" cy="296.2" r="152.5"/>
        <g id="XMLID_2_">
          <path id="XMLID_27_" class="st46" d="M358.9,342"/>
          <path id="XMLID_298_" class="st47" d="M327.9,336.1v66.7H200v-66.7c0-1.4,0-2.9,0.2-4.3c0-0.2,0-0.5,0.1-0.7
            c0.1-1.7,0.3-3.4,0.6-5c1.5-9.2,5.1-17.7,10.3-25.1c6.5-9.3,15.5-16.7,25.9-21.2c1.2-0.5,2.4-1,3.6-1.5c0.5-0.2,1-0.4,1.5-0.5
            c6.1-2,12.6-3.1,19.3-3.1h5c1.5,0,3,0.1,4.5,0.2c0.7,0,1.4,0.1,2,0.2c2.4,0.3,4.7,0.6,6.9,1.2c1.5,0.3,3,0.7,4.5,1.2h0
            c0.7,0.2,1.4,0.5,2.2,0.7c3.5,1.2,6.9,2.7,10,4.6c1.2,0.7,2.4,1.4,3.6,2.2c2.1,1.4,4.1,2.9,6,4.5c2.4,2,4.6,4.2,6.6,6.5
            c5.4,6.2,9.6,13.5,12.2,21.5c0,0.1,0.1,0.3,0.1,0.4c1.1,3.4,1.9,6.9,2.3,10.6C327.7,330.9,327.9,333.5,327.9,336.1z"/>
          <rect id="XMLID_177_" x="242.2" y="274.7" class="st48" width="44.4" height="128.1"/>
          <path id="XMLID_174_" class="st49" d="M286.6,274.7v10.2c-5.1,6.1-12.5,10.4-21,11.7c-1.6,0.2-3.2,0.4-4.7,0.4
            c-6.8,0.1-13.2-1.9-18.7-5.4v-16.8H286.6z"/>
          <rect id="XMLID_512_" x="200" y="365" class="st50" width="127.8" height="37.8"/>
          <rect id="XMLID_501_" x="242.2" y="365" class="st51" width="44.4" height="37.8"/>
          <g id="XMLID_5_">
            <g id="XMLID_23_">
              <path id="XMLID_93_" class="st52" d="M288.2,272.4c-5.1,8-13.5,13.9-23.7,15.4c-1.6,0.2-3.2,0.4-4.7,0.4
                c-16.7,0.2-31.4-12-33.9-29l-5.2-34.7c-2.8-18.6,10.1-35.9,28.6-38.7c1.7-0.3,3.4-0.4,5-0.4c16.6,0,31.1,12.1,33.6,29l5.1,34.7
                C294.4,257.6,292.4,265.8,288.2,272.4z"/>
              <path id="XMLID_35_" class="st52" d="M288.2,272.4c-5.1,8-13.5,13.9-23.7,15.4c-1.6,0.2-3.2,0.4-4.7,0.4
                c-16.7,0.2-31.4-12-33.9-29l-5.2-34.7c-2.8-18.6,10.1-35.9,28.6-38.7c1.7-0.3,3.4-0.4,5-0.4c16.6,0,31.1,12.1,33.6,29l5.1,34.7
                C294.4,257.6,292.4,265.8,288.2,272.4z"/>
              <path id="XMLID_89_" class="st53" d="M288.2,272.4c-5.1,8-13.5,13.9-23.7,15.4c-1.6,0.2-3.2,0.4-4.7,0.4c0.2-0.3,0.4-0.7,0.6-1
                l1-1.3c0-1.7,0.8-3.4,2.2-4.4l3.3-2.5c-0.4-1.2,0.2-2.4,1.3-3l3.1-1.4l-3.1-4.2c-0.5-0.6-0.7-1.3-0.7-2c0-1.2,0.7-2.3,1.8-3
                c2.8-2,4.7-2.2,5.8-1.2l9.8,8.8l0.7,0.2C286.4,272.8,287.3,272.5,288.2,272.4z"/>
              <path id="XMLID_30_" class="st53" d="M263.8,283.2L263.8,283.2c-18.6,2.8-35.9-10.1-38.7-28.6l0.7,4.7
                c2.8,18.6,20.1,31.4,38.7,28.6h0c18.6-2.8,31.4-20.1,28.6-38.7l-0.7-4.7C295.2,263.1,282.4,280.4,263.8,283.2z"/>
              <path id="XMLID_48_" class="st53" d="M214.4,212.7c1.8,1.6,3.7,2.9,5.4,3.6c0.7,0.4,7.7,3.9,10.8,4.4c6.3,1.5,14.6,0.9,22.9-2.2
                c13.7-5.2,22.8-15.5,21.8-24L214.4,212.7z"/>
              <path id="XMLID_49_" class="st54" d="M223.4,242.6c-6,1.2-10.2,6.3-9.4,11.6l0,0c0.8,5.4,6.3,9,12.4,8.4L223.4,242.6z"/>
              <path id="XMLID_7_" class="st55" d="M223.9,246.1c-3.9,0.8-6.6,4.1-6.1,7.5l0,0c0.5,3.5,4.1,5.8,8,5.4L223.9,246.1z"/>
              <path id="XMLID_12_" class="st54" d="M290.2,232.6c6.1-0.6,11.6,3,12.4,8.4l0,0c0.8,5.4-3.4,10.5-9.4,11.6L290.2,232.6z"/>
              <path id="XMLID_9_" class="st55" d="M290.7,236.2c4-0.4,7.5,2,8,5.4v0c0.5,3.5-2.2,6.7-6.1,7.5L290.7,236.2z"/>
              <path id="XMLID_14_" class="st53" d="M268.3,267.4c1.3,2.9,0.4,6.1-2.1,7.4l0,0c-2.5,1.2-5.6,0-7.2-2.7L268.3,267.4z"/>
              <path id="XMLID_8_" class="st56" d="M292.2,209.3c0.3-2.5-0.1-5.4-1.2-8.2c-2.3-5.8-7.2-9.5-11.4-8.6c-3.6,0.8-5.9,4.5-6.1,9.1
                c-0.5,4,0.1,9.5,2,15.3c3.3,10.5,9.3,18,13.4,16.7c2.9-0.9,4.1-6,3.3-12.6C291.8,217,291.8,213,292.2,209.3z"/>
              <path id="XMLID_19_" class="st56" d="M230.1,223.5c-0.1,11-3.7,19.9-8,19.9c-3,0-5.6-4.5-6.8-11c-0.7-3.9-1.9-7.6-3.4-11.1
                c-0.3-0.6-0.5-1.2-0.7-1.9c-0.5-1.9-0.8-4.1-0.6-6.3c0.1-0.9,0.2-1.8,0.4-2.7c1.1-4.9,4.3-8.6,8-8.9c3.7-0.3,6.9,2.6,8.5,6.9
                C229.2,212,230.2,217.5,230.1,223.5z"/>
              <path id="XMLID_28_" class="st57" d="M250.8,213.7c-8.7,1.9-16.9,1.4-23-1.1c-3-0.9-9.4-5.4-10-5.9c-2.4-1.5-5.1-4.2-7.3-7.7
                c-4-6.4-5.1-13.1-2.3-14.8c1.6-1,4.2-0.2,6.8,2c0.8-2.1,1.9-4,3.3-5.7c2.2-2.6,5-4.7,8.4-5.8c3.5-1.2,7.1-1.2,10.4-0.3
                c0.7,0.2,1.3,0.4,1.9,0.6c5.7,2.2,11.5,3.6,17.5,4.1c9.9,0.7,17.6,5,19,11.5C277.7,199.8,266.6,210.2,250.8,213.7z"/>
              <path id="XMLID_24_" class="st58" d="M257.9,199.1c-2,5.5-8.7,8.3-14.5,7.6c-5-0.6-9.5-3.1-13.7-6c1.7,0.2,3.5,0.1,5.2-0.3
                c2.6-0.5,5.3-1.6,6.8-3.8c1.5-2.2,1.4-5.7-0.8-7.2c-3.1,1.4-6.8,1.7-9.7,0.1c-2.9-1.6-4.6-5.6-2.9-8.6c0.7-1.2,1.8-2.8,0.8-3.7
                c-3.7-0.2-7.5,1-10.6,3.2c-0.1-0.1-0.1-0.2-0.2-0.2c2.2-2.6,5-4.7,8.4-5.8c3.5-1.2,7.1-1.2,10.4-0.3c0.1,0.1,0.3,0.2,0.4,0.3
                c0.8,0.5,1.7,0.7,2.3,1.4c1,1.2,0.4,3.1,1,4.5c0.7,1.7,2.7,2.4,4.5,2.3c1.8-0.1,3.6-0.6,5.4-0.5c0.9,0.1,1.8,0.4,2.2,1.1
                c1.3,2.4-3.9,4.3-3,6.9c4.6-1.1,9.4-1.5,14.1-1.1c-4.5,1.6-8.8,3.8-12.8,6.4c-1.9,1.3-3.8,4.1-2,5.5
                C251.7,203.1,255.1,197.6,257.9,199.1z"/>
              <path id="XMLID_15_" class="st58" d="M225.1,216.7c-4.6,0.9-9.1,1.8-13.7,2.6c-0.1,0-0.1,0-0.2,0c-0.5-1.9-0.8-4.1-0.6-6.3
                c0.1-0.9,0.2-1.8,0.4-2.7c0.9,0.6,1.9,1.2,2.8,1.7c2.7,1.6,5.5,3.1,8.7,3.3C223.6,215.5,225,215.6,225.1,216.7z"/>
              <path id="XMLID_17_" class="st59" d="M246,228L246,228c0.6-0.8,0.4-1.9-0.4-2.3c-4.2-2.3-9.9-1.8-12.9,2.6
                c-1.2,1.7-0.9,3.9-0.1,4c0.8,0.1,1.8-1.1,2.5-2.2c2-3,5.9-3.4,8.8-1.8c0.6,0.3,1.4,0.3,1.9-0.1C245.9,228,245.9,228,246,228z"/>
              <path id="XMLID_10_" class="st59" d="M257.5,223.9L257.5,223.9c-0.6,0.8-0.4,1.9,0.4,2.3c4.2,2.3,9.9,1.8,12.9-2.6
                c1.2-1.7,0.9-3.9,0.1-4c-0.8-0.1-1.8,1.1-2.5,2.2c-2,3-5.9,3.4-8.8,1.8c-0.6-0.3-1.4-0.3-1.9,0.1
                C257.6,223.8,257.6,223.9,257.5,223.9z"/>
              <path id="XMLID_11_" class="st53" d="M261.3,260l-3.8,0.6c-5.2,0.8-6.8-11.4-5.4-17.8l2.1-9.8c0.1-0.3,0.5-0.5,1-0.6l0.3-0.1
                c0.5-0.1,1,0,1.1,0.3l4.8,8.8C264.5,247.1,266.5,259.2,261.3,260z"/>
              <path id="XMLID_16_" class="st60" d="M263,252.8c-0.9,0.1-1.7,0.8-2,1.7c-0.2,0.7-0.7,1.2-1.3,1.3l-1.9,0.3
                c-0.7,0.1-1.2-0.2-1.7-0.8c-0.5-0.8-1.5-1.2-2.4-1l-1.4,0.2c0.9,3.7,2.6,6.6,5.2,6.2l3.8-0.6c2.6-0.4,3.4-3.6,3.2-7.4L263,252.8
                z"/>
              <path id="XMLID_13_" class="st61" d="M260.3,251.1c0.2,1.1-0.6,2-1.6,2.2c-1.1,0.2-2-0.6-2.2-1.6c-0.2-1.1,0.6-2,1.6-2.2
                C259.1,249.3,260.1,250,260.3,251.1z"/>
              <path id="XMLID_18_" class="st59" d="M271.7,261.8c-7,0.3-10.9,7.1-17.9,7.4c-0.4,0-0.8,0-0.8,0l0,0c0,0,0.4,0,0.8-0.1
                c6.6-1.1,10.2-8.7,16.7-9.9c0.4-0.1,1,0.5,1.4,1.2v0C272.2,261.2,272.1,261.8,271.7,261.8z"/>
            </g>
            <path id="XMLID_55_" class="st59" d="M252.7,243.5c-0.1-0.6-0.2-1.3-0.4-1.9c-1.9-6.7-8.5-11-15.6-10c-3.4,0.5-6.4,2.2-8.5,4.6
              c-1.4,1.6-2.5,3.6-3.1,5.7c-0.5,1.8-0.6,3.8-0.3,5.7c1.1,7.7,8.3,13,16,11.9c5.1-0.7,9.1-4.1,10.9-8.5
              C252.7,248.7,253.1,246.2,252.7,243.5z M240.4,256.6c-6.1,0.9-11.8-3.3-12.7-9.4c-0.9-6.1,3.3-11.8,9.4-12.7
              c6.1-0.9,11.8,3.3,12.7,9.4C250.7,250,246.5,255.7,240.4,256.6z"/>
            <path id="XMLID_47_" class="st59" d="M290.4,237.9c-0.2-1.6-0.7-3.1-1.4-4.4c-1.9-3.7-5.3-6.3-9.4-7.2c-1.7-0.4-3.4-0.5-5.2-0.2
              c-7.7,1.1-13,8.3-11.9,16c1.1,7.7,8.3,13,16,11.9C286.2,252.8,291.5,245.6,290.4,237.9z M278.1,251c-6.1,0.9-11.8-3.3-12.7-9.4
              c-0.9-6.1,3.3-11.8,9.4-12.7c3.1-0.5,6.2,0.4,8.5,2.2c0.4,0.3,0.8,0.7,1.2,1c1.6,1.6,2.7,3.7,3.1,6.2
              C288.4,244.4,284.2,250.1,278.1,251z"/>
            <g id="XMLID_62_">
              <path id="XMLID_37_" class="st59" d="M246.7,240.9c0.3,1.9-1,3.6-2.9,3.9c-1.9,0.3-3.6-1-3.9-2.9c-0.3-1.9,1-3.6,2.9-3.9
                C244.7,237.7,246.5,239,246.7,240.9z"/>
              <path id="XMLID_61_" class="st61" d="M244.7,240.4c0.1,0.4-0.2,0.8-0.7,0.9c-0.4,0.1-0.8-0.2-0.9-0.7c-0.1-0.4,0.2-0.8,0.7-0.9
                C244.3,239.7,244.7,240,244.7,240.4z"/>
            </g>
            <g id="XMLID_64_">
              <path id="XMLID_68_" class="st59" d="M278,236.2c0.3,1.9-1,3.6-2.9,3.9c-1.9,0.3-3.6-1-3.9-2.9c-0.3-1.9,1-3.6,2.9-3.9
                C276,233.1,277.7,234.4,278,236.2z"/>
              <path id="XMLID_65_" class="st61" d="M276,235.8c0.1,0.4-0.2,0.8-0.7,0.9c-0.4,0.1-0.8-0.2-0.9-0.7c-0.1-0.4,0.2-0.8,0.7-0.9
                C275.6,235,276,235.3,276,235.8z"/>
            </g>
          </g>
          <polygon id="XMLID_21_" class="st62" points="354.2,336.8 306.2,289.4 303.9,322.7 315.2,342 		"/>
          <polygon id="XMLID_79_" class="st47" points="174.9,336.8 222.9,289.4 225.2,322.7 213.9,342 		"/>
          <line id="XMLID_26_" class="st47" x1="354.2" y1="336.8" x2="306.2" y2="289.4"/>
          <ellipse id="XMLID_22_" class="st48" cx="332.7" cy="354.6" rx="29.1" ry="26.8"/>
          <path id="XMLID_31_" class="st54" d="M347.1,337.2l-42-37.5l-7.7-22.8c-0.5-1.4-1.4-2.6-2.7-3.4l0,0c-2.1-1.3-4.7-1.4-6.8-0.2
            l-2.5,1.4l-9.8-8.8c-1.1-1-2.7-1.2-4-0.4l0,0c-1.8,1-2.3,3.4-1.1,5.1l3.1,4.2l-3.1,1.4c-1.1,0.5-1.7,1.8-1.3,3l0,0l-3.3,2.5
            c-1.4,1-2.2,2.7-2.2,4.4l0,0l-1,1.3c-1.6,2.2-2.2,5-1.5,7.7l0,0c0.8,3,2.9,5.3,5.8,6.4l1.2,0.4l11.5,10l7.3,4.5l24.6,44.9
            c2.6,4.7,6.9,8.2,12,9.7l3.9,1.2c10.1,3,20.9-2.1,24.8-11.9h0C355.7,352.1,353.6,342.9,347.1,337.2z"/>
          <path id="XMLID_25_" class="st52" d="M347.1,337.2l-42-37.5l-7.7-22.8c-0.5-1.4-1.4-2.6-2.7-3.4l0,0c-2.1-1.3-4.7-1.4-6.8-0.2
            l-2.5,1.4l-9.8-8.8c-1.1-1-2.7-1.2-4-0.4l0,0c-1.8,1-2.3,3.4-1.1,5.1l3.1,4.2l-3.1,1.4c-1.1,0.5-1.7,1.8-1.3,3l0,0l-3.3,2.5
            c-1.4,1-2.2,2.7-2.2,4.4l0,0l-1,1.3c-1.6,2.2-2.2,5-1.5,7.7l0,0c0.8,3,2.9,5.3,5.8,6.4l1.2,0.4l11.5,10l7.3,4.5l24.6,44.9
            c2.6,4.7,6.9,8.2,12,9.7l3.9,1.2c10.1,3,20.9-2.1,24.8-11.9h0C355.7,352.1,353.6,342.9,347.1,337.2z"/>
          <g id="XMLID_77_">
            <g>
              <g id="XMLID_81_">
                <path class="st63" d="M281.6,271.5l0.2-0.1l-6.1-5.4c-0.3-0.3-0.7-0.5-1-0.6L281.6,271.5z"/>
              </g>
              <g id="XMLID_76_">
                <path class="st53" d="M347.1,337.2l-42-37.5l-7.7-22.8c-0.5-1.4-1.4-2.6-2.7-3.4c-0.5-0.3-1.1-0.6-1.7-0.8
                  c0.2,0.3,0.3,0.6,0.4,1l7.7,22.8l42,37.5c6.4,5.7,8.6,14.9,5.3,22.9l0,0c-4,9.8-14.7,14.9-24.8,11.9l-3.9-1.2
                  c-1.8-0.5-3.5-1.3-5.1-2.3c2.4,2.6,5.5,4.5,9,5.6l3.9,1.2c10.1,3,20.9-2.1,24.8-11.9h0C355.7,352.1,353.6,342.9,347.1,337.2z"
                  />
              </g>
            </g>
          </g>
          <path id="XMLID_32_" class="st53" d="M276.1,291.8l4.6-2c2.5-1.1,4.7-2.7,6.5-4.8v0c2-2.3,5.8-1.8,7,1l4.4,9.9
            c1.7,3.9,1.1,8.5-1.7,11.7l0,0c-3.6,4.2-10.1,4.3-13.8,0.2l-8.5-9.4C272.7,296.4,273.4,293,276.1,291.8z"/>
          
            <ellipse id="XMLID_117_" transform="matrix(0.8043 -0.5942 0.5942 0.8043 -171.7266 184.6147)" class="st48" cx="194.4" cy="353" rx="26.8" ry="29.1"/>
          <path id="XMLID_114_" class="st52" d="M199.9,331l55.1,11.5l22.9-7.4c1.4-0.5,3-0.4,4.4,0.1l0,0c2.3,0.9,3.9,2.9,4.2,5.4l0.3,2.8
            l12.9,2.6c1.5,0.3,2.6,1.5,2.7,3l0,0c0.3,2.1-1.4,3.9-3.4,3.9l-5.2,0l0.7,3.3c0.3,1.2-0.4,2.4-1.6,2.8l0,0l0,4.2
            c0,1.7-0.8,3.4-2.2,4.4l0,0l-0.5,1.6c-0.8,2.6-2.8,4.7-5.3,5.8l0,0c-2.8,1.1-6,0.8-8.6-0.9l-1.1-0.7l-14.8-3.3l-7.9-3.2l-50.7,6.9
            c-5.3,0.7-10.7-0.7-15-3.9l-3.3-2.4c-8.4-6.3-10.7-18-5.2-27v0C182.8,333,191.4,329.3,199.9,331z"/>
          <g id="XMLID_33_">
            <g>
              <g id="XMLID_60_">
                <path class="st63" d="M291.7,344.7l0-0.2l8,1.6c0.4,0.1,0.8,0.2,1.1,0.4L291.7,344.7z"/>
              </g>
              <g id="XMLID_56_">
                <path class="st53" d="M199.9,331l55.1,11.5l22.9-7.4c1.4-0.5,3-0.4,4.4,0.1c0.6,0.2,1.1,0.5,1.6,0.9c-0.3,0.1-0.7,0.1-1,0.2
                  l-22.9,7.4l-55.1-11.5c-8.4-1.8-17.1,2-21.6,9.3v0c-5.5,9-3.3,20.7,5.2,27l3.3,2.4c1.5,1.1,3.2,2,4.9,2.7
                  c-3.5-0.4-6.9-1.8-9.8-3.9l-3.3-2.4c-8.4-6.3-10.7-18-5.2-27v0C182.8,333,191.4,329.3,199.9,331z"/>
              </g>
            </g>
          </g>
          <path id="XMLID_29_" class="st53" d="M278.6,361.3l-1.1-4.9c-0.6-2.6-0.6-5.4,0-8l0,0c0.7-3-2-5.7-5-5.1l-10.6,2.3
            c-4.2,0.9-7.5,4.2-8.4,8.3v0c-1.3,5.4,2.5,10.7,8,11.2l12.6,1.3C276.9,366.7,279.2,364.1,278.6,361.3z"/>
        </g>
        <g>
          <path class="st7" d="M547.1,198.2l-21.4,5.6L526,215l-17.4-0.5l-0.3-7.9c-4.3,0.6-9.9,0.2-16.6-1c-14.8-2.9-22.1-9.9-22.1-21.2
            c0-7.6,2.9-15.6,8.7-24.1c4.9-7.2,10.4-12.7,16.4-16.5l12.2,10.7c-4.8,3.8-9.1,8.3-12.7,13.4c-4.4,5.9-6.6,10.9-6.6,14.9
            c0,5.3,6.9,7.9,20.6,7.9c0.1-4.3,1-11.4,2.7-21.3c0.1-0.7,1.7-8.9,4.7-24.6l16.1,3.9c-1,6.7-2.1,14.4-3.3,23.3
            c-1.3,8.9-2.1,14.3-2.2,16.2l16.7-4.5L547.1,198.2z"/>
          <path class="st7" d="M630.3,175c0,11.1-3.8,20.6-11.3,28.4c-7.5,7.7-16.9,11.6-28.1,11.6c-10.2,0-18.9-2.8-26.2-8.3
            c-8-6.1-12-14.1-12-24.1c0-12.4,3.9-22,11.6-28.9c7.4-6.6,17.4-9.9,30-9.9c9.3,0,17.4,2.8,24.4,8.5
            C626.4,158.3,630.3,165.9,630.3,175z M611.8,176.5c0-5-2.3-9-6.9-12c-4-2.6-8.6-3.9-14-3.9c-6.1,0-11,2-14.7,6
            c-3.8,4-5.6,9.1-5.6,15.2c0,4.9,2.3,8.8,6.8,11.7c3.9,2.4,8.5,3.7,13.9,3.7c6.1,0,11-1.9,14.9-5.8
            C609.9,187.5,611.8,182.6,611.8,176.5z"/>
          <path class="st7" d="M713.5,198.2l-21.4,5.6l0.3,11.2l-17.4-0.5l-0.3-7.9c-4.3,0.6-9.9,0.2-16.6-1c-14.8-2.9-22.1-9.9-22.1-21.2
            c0-7.6,2.9-15.6,8.7-24.1c4.9-7.2,10.4-12.7,16.4-16.5l12.2,10.7c-4.8,3.8-9.1,8.3-12.7,13.4c-4.4,5.9-6.6,10.9-6.6,14.9
            c0,5.3,6.9,7.9,20.6,7.9c0.1-4.3,1-11.4,2.7-21.3c0.1-0.7,1.7-8.9,4.7-24.6l16.1,3.9c-1,6.7-2.1,14.4-3.3,23.3
            c-1.3,8.9-2.1,14.3-2.2,16.2l16.7-4.5L713.5,198.2z"/>
        </g>
      </g>
      </svg>
    </div>
    <div class="msg">{{message}}</div>
  </div>
</template>

<script>
export default {
  name:'state404',
  props: {
    message: {
      type: String,
      default:'您所访问的页面不存在！'
    },
  },
}
</script>
<style>
  .msg{    
    position: absolute;
    width: 270px;
    top: 257px;
    right: 15px;
    font-size: 16px;
    font-weight: 700;
  }
  .st0{opacity:0.51;fill:#E2E3E3;}
  .st1{fill:#FADA28;}
  .st2{fill:#131733;}
  .st3{fill:none;stroke:#E37100;stroke-width:2;stroke-miterlimit:10;}
  .st4{fill:#E37100;}
  .st5{clip-path:url(#SVGID_2_);fill:#131733;}
  .st6{clip-path:url(#SVGID_4_);fill:#131733;}
  .st7{fill:#3940C7;}
  .st8{fill:#EF6693;}
  .st9{fill:#FFFFFF;}
  .st10{fill:#6E74E0;}
  .st11{fill:#985CFF;}
  .st12{fill:#FFD426;}
  .st13{fill:#DE4531;}
  .st14{fill:#34BF47;}
  .st15{clip-path:url(#SVGID_6_);}
  .st16{fill:#87ECF3;}
  .st17{fill:none;stroke:#141221;stroke-miterlimit:10;}
  .st18{fill:none;stroke:#141221;stroke-width:0.25;stroke-miterlimit:10;}
  .st19{fill:#161421;}
  .st20{fill:none;stroke:#FADA28;stroke-miterlimit:10;}
  .st21{fill:none;stroke:#000000;stroke-miterlimit:10;}
  .st22{fill:#A3AEA7;}
  .st23{fill:#312D54;}
  .st24{fill:#F2F4F3;}
  .st25{fill:#89EEF5;}
  .st26{fill:#289437;}
  .st27{fill:#C6C7CB;}
  .st28{fill:#E7E7E9;}
  .st29{fill:none;stroke:#919191;stroke-width:0.75;stroke-linecap:round;stroke-miterlimit:10;}
  .st30{fill:#CACACE;}
  .st31{fill:#535258;}
  .st32{fill:none;stroke:#89EEF5;stroke-width:0.5;stroke-miterlimit:10;}
  .st33{fill:none;stroke:#131221;stroke-width:0.5;stroke-miterlimit:10;}
  .st34{fill:none;stroke:#DE4531;stroke-width:0.5;stroke-miterlimit:10;}
  .st35{fill:none;stroke:#3F81CC;stroke-linecap:round;stroke-miterlimit:10;}
  .st36{fill:none;stroke:#131221;stroke-miterlimit:10;}
  .st37{fill:none;stroke:#131221;stroke-width:0.25;stroke-miterlimit:10;}
  .st38{fill:none;stroke:#DE4531;stroke-width:2;stroke-miterlimit:10;}
  .st39{fill:none;stroke:#161421;stroke-miterlimit:10;}
  .st40{fill:#131221;}
  .st41{opacity:0.34;fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-miterlimit:10;}
  .st42{fill:none;stroke:#C73030;stroke-width:2;stroke-miterlimit:10;}
  .st43{opacity:0.41;fill:#FFFFFF;}
  .st44{opacity:0.15;clip-path:url(#SVGID_8_);fill:#8061D4;}
  .st45{opacity:0.57;fill:#FFFFFF;}
  .st46{fill:#EE9325;}
  .st47{fill:#004273;}
  .st48{fill:#EAF1E8;}
  .st49{fill:#B6BFB3;}
  .st50{fill:#0D3552;}
  .st51{fill:#A5D099;}
  .st52{fill:#FFCCB9;}
  .st53{fill:#FF9D81;}
  .st54{fill:#FA976E;}
  .st55{fill:#BA474C;}
  .st56{fill:#53191F;}
  .st57{fill:#6C1D25;}
  .st58{fill:#A52722;}
  .st59{fill:#773038;}
  .st60{fill:#AB5B3A;}
  .st61{fill:#FEE3DA;}
  .st62{fill:#2D5573;}
  .st63{fill:#FF7358;}
</style>


// WEBPACK FOOTER //
// src/components/states/state404.vue